import { render, staticRenderFns } from "./FileControls.vue?vue&type=template&id=09b4f265"
import script from "./FileControls.vue?vue&type=script&lang=js"
export * from "./FileControls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports